import {
  Card as MuiCard,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Stack,
  CircularProgress,
  ButtonProps,
  Button,
} from '@mui/material';

interface Props {
  title: string;
  description?: string;
  image?: string;
  isLoading?: boolean;
  actions?: ButtonProps[];
  direction?: 'row' | 'column';
  style?: React.CSSProperties;
}

const Card = ({
  title,
  description,
  image,
  actions,
  isLoading = false,
  direction,
  style,
}: Props) => {
  if (isLoading) {
    return (
      <Stack flex={1} direction="row" justifyContent="center">
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <MuiCard
      sx={
        direction === 'row'
          ? { display: 'flex', borderRadius: '12px', ...style }
          : { width: '350px', ...style }
      }
    >
      <Stack
        direction={direction}
        sx={direction === 'row' ? { display: 'flex', flex: 1 } : { flex: 1 }}
      >
        <CardMedia
          image={image || '/placeholder.png'}
          title={title}
          sx={
            direction === 'row'
              ? { width: 130, height: 130 }
              : { height: '140px' }
          }
        />
        <Stack
          display={'flex'}
          sx={direction === 'row' ? { flex: 1 } : { flex: 'none' }}
        >
          <CardContent>
            <Typography gutterBottom variant="h3" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </CardContent>
          {actions && actions.length > 0 ? (
            <CardActions>
              <Stack spacing={2} direction="row" flex={1}>
                {actions.map((action, index) => (
                  <Button key={index} {...action} />
                ))}
              </Stack>
            </CardActions>
          ) : null}
        </Stack>
      </Stack>
    </MuiCard>
  );
};

export default Card;
